export default __webpack_public_path__ + "static/media/reg-side-img.825a39b5.svg";